let REACT_APP_API_URL = process.env.REACT_APP_API_URL;
if (!process.env.REACT_APP_API_URL) REACT_APP_API_URL = process.env.REACT_APP_API_DEV_URL;

export const requestCommunityDify = async (formData) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/prompt/chat-messages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      query: `Olá, Zê! Tudo bem? Crie um plano de comunidade com as seguintes informações:
        - Propósito: ${formData.purpose}
        - Tipo de assinatura: ${formData.subscription}
        - Plataforma(s): ${Array.isArray(formData.platform) ? formData.platform.join(', ') : (formData.platform || '')}
        - Conteúdo existente: ${formData.content || 'Nenhum'}
        - Tipo de conteúdo planejado: ${(Array.isArray(formData.contentTypes) ? formData.contentTypes.join(', ') : formData.contentTypes) || 'Nenhum'}
        - Tipos de comunicação: ${Array.isArray(formData.communicationTypes) ? formData.communicationTypes.join(', ') : (formData.communicationTypes || '')}
        - Informações especiais: ${formData.specialInfo || 'Nenhuma informação adicional fornecida'}`,
      inputs: {},
      response_mode: "streaming",
      user: "community-builder-"
    })
  });

  const data = await response.json();
  return data;
};

export const requestCalendarDify = async (formData) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/prompt/chat-messages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      query: `Olá, Zê! Tudo bem? Crie um calendário de conteúdo com as seguintes informações:
        - Nome da comunidade: ${formData.name}
        - Tagline da comunidade: ${formData.tagline}
        - Propósito: ${formData.purpose}
        - Tipo de assinatura: ${formData.subscription}
        - Plataforma(s): ${Array.isArray(formData.platform) ? formData.platform.join(', ') : (formData.platform || '')}
        - Conteúdo existente: ${formData.content || 'Nenhum'}
        - Tipo de conteúdo planejado: ${(Array.isArray(formData.contentTypes) ? formData.contentTypes.join(', ') : formData.contentTypes) || 'Nenhum'}
        - Tipos de comunicação: ${Array.isArray(formData.communicationTypes) ? formData.communicationTypes.join(', ') : (formData.communicationTypes || '')}
        - Informações especiais: ${formData.specialInfo || 'Nenhuma informação adicional fornecida'}
        - Tonalidade: ${formData.tone || 'Nenhuma'}
        - Tonalidade personalizada: ${formData.customTone || 'Nenhuma'}
        - Formatos de conteúdo: ${(Array.isArray(formData.contentFormats) ? formData.contentFormats.join(', ') : formData.contentFormats) || 'Nenhum'}
        - Formatos de conteúdo personalizado: ${formData.customContentFormat || 'Nenhuma'}
        - Frequência de publicação: ${formData.frequency || 'Nenhuma'}`,
      inputs: {},
      response_mode: "streaming",
      user: "calendar-builder-"
    })
  });

  const data = await response.json();
  return data;
};

export const requestScriptDify = async (formData) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/prompt/chat-messages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      query: `Olá, Zê! Preciso criar um roteiro detalhado para o seguinte conteúdo:
        
        Descrição do Conteúdo: ${formData.contentDescription}
        Formato do Conteúdo: ${formData.formatText}
        Objetivo: ${formData.objectiveText}
        Semana do Calendário: ${formData.weekNumber}
        Tipo de Conteúdo: ${formData.postType === 'highlight' ? 'Destaque da semana' : 'Post regular'}
        Observações Adicionais: ${formData.observation || 'Nenhuma observação adicional'}
        ${formData.templateSection}
        
        Por favor, crie um roteiro completo com:
        
        1. Uma introdução que capte a atenção
        2. Um desenvolvimento com os pontos principais
        3. Uma conclusão com chamada para ação
        4. Sugestões de elementos visuais
        5. Dicas de tempo para cada parte (se for vídeo)
        6. Sugestões de legendas ou textos
        
        O roteiro deve ser específico para o formato ${formData.formatText} e otimizado para o objetivo de ${formData.objectiveText}.
        Mantenha a linguagem conversacional e adequada para o público da comunidade.
        
        IMPORTANTE: Se houver OBSERVAÇÕES ADICIONAIS, SEMPRE levá-las em consideração na construção do roteiro. Se houver sugestões fornecidas acima, use-as como inspiração e referência para criar o roteiro, aproveitando ao máximo as ideias prontas. Não utilize texto com markdown.`,
      inputs: {},
      response_mode: "streaming",
      user: "script-builder-"
    })
  });

  const data = await response.json();
  return data;
};

export const getMonthlyTokenUsage = async () => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/prompt/monthly-tokens`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });

  const tokensUsed = await response.text();

  const data = Number(tokensUsed);
  return data;
};

export const requestSinglePostDify = async (formData) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/prompt/chat-messages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      query: `Preciso gerar uma nova versão do seguinte post para uma comunidade:

        POST ATUAL:
        - Título: ${formData.currentTitle}
        - Descrição: ${formData.currentDescription}
        - Formato: ${formData.format}
        - Objetivo: ${formData.objective}
        - Templates atuais: ${formData.currentTemplates ? JSON.stringify(formData.currentTemplates) : 'Nenhum template'}

        FEEDBACK DO USUÁRIO:
        - O que não gostou: ${formData.feedback}
        - Como gostaria que fosse: ${formData.howWouldLike}

        CONTEXTO DA COMUNIDADE:
        - Nome: ${formData.name}
        - Propósito: ${formData.purpose}
        - Plataforma(s): ${Array.isArray(formData.platform) ? formData.platform.join(', ') : (formData.platform || '')}
        - Tonalidade: ${formData.tone || formData.customTone || 'Nenhuma'}

        IMPORTANTE: A descrição deve ser CONCISA e DIRETA, explicando apenas a ideia do post, de forma imperativa, direcionada para o criador de conteúdo. 
        IMPORTANTE: Em hipótese alguma coloque "Post 1, 2, 3, 4, etc" no início da título.

        Responda APENAS com o JSON no formato:
        {
          "title": "Título do post",
          "description": "Descrição do post",
          "templates": {
            "captions": [""],
            "visualSuggestions": [""],
            "interactiveQuestions": [""],
            "engagementChecklist": [""],
            "quickIdeas": ["", ""]
          }
        }`,
      inputs: {},
      response_mode: "streaming",
      user: "single-post-builder-"
    })
  });

  const data = await response.json();
  return data;
};
